import { createFileRoute, redirect } from '@tanstack/react-router';

import LoginPage from '@/pages/LoginPage';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const localToken = localStorage.getItem('auth-token');
    if (localToken) {
      throw redirect({ to: '/home' });
    }
    return {};
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <LoginPage />;
}
